import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { DataLoaderComponent } from './data-loader/data-loader.component';

@NgModule({
	declarations: [DataLoaderComponent],
	exports: [DataLoaderComponent],
	imports: [CommonModule, NgbModule, TranslateModule]
})
export class DataLoaderModule {}
